import { useEffect } from "react";
import { isSameDay } from "date-fns/esm";
import { useLocalStorage } from "@rehooks/local-storage";
import { useShallow } from "zustand/react/shallow";

import { trackSegmentEvent } from "shared/Analytics";

import useMainNavigationStore from "../stores/useMainNavigationStore";

const ANALYTICS_STORAGE_KEY = "mainNavigation:lastAnalyticsDate";

// It sends a daily snapshot of user preferences to analytics
const useMainNavigationAnalytics = () => {
  const [lastAnalyticsDate, setLastAnalyticsDate] = useLocalStorage<string>(ANALYTICS_STORAGE_KEY);

  const { isSidebarExpanded, defaultViewItemId, pinnedItemIds, expandedGroupIds } =
    useMainNavigationStore(
      useShallow((state) => ({
        isSidebarExpanded: state.isSidebarExpanded,
        defaultViewItemId: state.defaultViewItemId,
        pinnedItemIds: state.pinnedItemIds,
        expandedGroupIds: state.expandedGroupIds,
      }))
    );

  useEffect(() => {
    const today = new Date();
    const lastSent = lastAnalyticsDate ? new Date(lastAnalyticsDate) : undefined;

    if (!lastSent || !isSameDay(lastSent, today)) {
      trackSegmentEvent("MainNavigation: store snapshot", {
        isSidebarExpanded,
        defaultViewItemId: defaultViewItemId ?? undefined,
        pinnedItemIds,
        pinnedItemsCount: pinnedItemIds.length,
        expandedGroupIds: Array.from(expandedGroupIds),
        expandedGroupsCount: expandedGroupIds.size,
      });

      setLastAnalyticsDate(today.toISOString());
    }
  }, [
    isSidebarExpanded,
    defaultViewItemId,
    pinnedItemIds,
    expandedGroupIds,
    lastAnalyticsDate,
    setLastAnalyticsDate,
  ]);
};

export default useMainNavigationAnalytics;
